import React, {Component} from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import API_Root from '../../Constants/API_Root'
import API_Backend_Root from "../../Constants/API_Backend_Root";

class AgentsBuildIndex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentStep: 1,
            files: [],
            selectedFiles: [],
            selectedOutputFormats: [], 
            fileDescriptions: {}, 
            selectedFileForDescription: null, 
            agentName: '', 
            agentDescription: '',
            agentInstructions: '', 
            loading: false,
            error: null,
        };
        this.handleBackToAgents = this.handleBackToAgents.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleFileDeselect = this.handleFileDeselect.bind(this);
        this.handleOutputFormatToggle = this.handleOutputFormatToggle.bind(this);
        this.handleFileDescriptionChange = this.handleFileDescriptionChange.bind(this); 
        this.handleNext = this.handleNext.bind(this);
        this.handleAgentNameChange = this.handleAgentNameChange.bind(this);
        this.handleAgentDescriptionChange = this.handleAgentDescriptionChange.bind(this);
        this.handleAgentInstructionsChange = this.handleAgentInstructionsChange.bind(this); 
    }

    getApiBaseUrl = () => {
        if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
            return 'http://127.0.0.1:8080/';
        }
        return "https://api.apispreadsheets.com/";
    }

    componentDidMount() {
        this.fetchUserFiles();

        const textarea = document.querySelector('textarea[placeholder*="Enter instructions for your AI agent"]');
        if (textarea) {
            textarea.style.height = 'auto';
            const newHeight = Math.max(300, Math.min(500, textarea.scrollHeight));
            textarea.style.height = newHeight + 'px';
        }
    }

    fetchUserFiles = async () => {
        try {
            this.setState({ loading: true, error: null });
            
            const userEmail = localStorage.getItem("email");
            const userToken = localStorage.getItem("token");
            
            if (!userEmail || !userToken) {
                this.setState({ 
                    error: "User authentication not found. Please log in again.",
                    loading: false 
                });
                return;
            }

            const current = new Date();

            const response = await fetch(API_Root + "api/get-api-files/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    utcOffset: current.getTimezoneOffset(),
                    email: userEmail,
                    token: userToken,
                    pkList: null,
                    teamPK: null,
                    importer: false,
                    api: true
                })
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch files: ${response.status}`);
            }

            const data = await response.json();
            
            if (data.error) {
                throw new Error(data.error);
            }
            
            // Transform the data to match our expected format
            // filePK is an array of {id: pkID, pk: pk}
            // fileInformation is an object with pkID as keys
            const files = [];
            if (data.filePK && data.fileInformation) {
                data.filePK.forEach(filePK => {
                    const fileInfo = data.fileInformation[filePK.id];
                    if (fileInfo) {
                        files.push({
                            pk: filePK.pk,
                            pkID: filePK.id,
                            name: fileInfo.name,
                            fileType: fileInfo.inputType,
                            createdDt: fileInfo.createdDt,
                            fileHash: fileInfo.fileHash
                        });
                    }
                });
            }
            
            this.setState({ 
                files: files,
                loading: false 
            });

        } catch (error) {
            console.error('Error fetching files:', error);
            this.setState({ 
                error: error.message || "Failed to fetch files",
                loading: false 
            });
        }
    };

    handleBackToAgents = () => {
        this.props.navigateTo('/ai');
    }

    handleStepClick = (stepNumber) => {
        this.setState({ currentStep: stepNumber });
    }

    handleFileSelect = (fileHash) => {
        console.log('File selected:', fileHash);
        
        // Check if we've reached the limit of 20 files
        if (this.state.selectedFiles.length >= 20) {
            console.log('Maximum of 20 files allowed');
            return;
        }
        
        this.setState(prevState => {
            const newSelectedFiles = [...prevState.selectedFiles, fileHash];
            console.log('All selected files:', newSelectedFiles);
            return { selectedFiles: newSelectedFiles };
        });
    }

    handleFileDeselect = (fileHash) => {
        console.log('File deselected:', fileHash);
        this.setState(prevState => {
            const newSelectedFiles = prevState.selectedFiles.filter(hash => hash !== fileHash);
            console.log('All selected files:', newSelectedFiles);
            return { selectedFiles: newSelectedFiles };
        });
    }

    handleOutputFormatToggle = (format) => {
        this.setState(prevState => {
            const isSelected = prevState.selectedOutputFormats.includes(format);
            const newSelectedFormats = isSelected
                ? prevState.selectedOutputFormats.filter(f => f !== format)
                : [...prevState.selectedOutputFormats, format];
            
            console.log('Selected output formats:', newSelectedFormats);
            return { selectedOutputFormats: newSelectedFormats };
        });
    }

    handleFileDescriptionChange = (fileHash, description) => {
        this.setState(prevState => ({
            fileDescriptions: {
                ...prevState.fileDescriptions,
                [fileHash]: description
            }
        }));
        console.log('File description updated for', fileHash, ':', description);
    }

    handleFileSelectForDescription = (fileHash) => {
        this.setState({ selectedFileForDescription: fileHash });
    }

    handleAgentNameChange = (e) => {
        this.setState({ agentName: e.target.value });
    }

    handleAgentDescriptionChange = (e) => {
        this.setState({ agentDescription: e.target.value });
    }

    handleAgentInstructionsChange = (e) => {
        this.setState({ agentInstructions: e.target.value });
        
        const textarea = e.target;
        textarea.style.height = 'auto';
        const newHeight = Math.max(300, Math.min(500, textarea.scrollHeight));
        textarea.style.height = newHeight + 'px';
    }

    handleNext = async () => {
        if (this.state.currentStep === 1) {
            this.setState({ currentStep: 2 });
        } else if (this.state.currentStep === 2) {
            try {
                this.setState({ loading: true, error: null });
                
                const userEmail = localStorage.getItem("email");
                const userToken = localStorage.getItem("token");
                
                if (!userEmail || !userToken) {
                    this.setState({ 
                        error: "User authentication not found. Please log in again.",
                        loading: false 
                    });
                    return;
                }

                // First, fetch the account keys using email
                const keysResponse = await fetch(API_Backend_Root + "fetch-account-keys/", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: userEmail
                    })
                });

                if (!keysResponse.ok) {
                    throw new Error(`Failed to fetch account keys: ${keysResponse.status}`);
                }

                const keysData = await keysResponse.json();
                
                if (keysData.error) {
                    throw new Error(keysData.error);
                }

                const { access_key, secret_key } = keysData;

                // Now use the fetched keys for the build agent request
                const requestBody = {
                    agentName: this.state.agentName,
                    agentDescription: this.state.agentDescription,
                    selectedFiles: this.state.selectedFiles,
                    fileDescriptions: this.state.fileDescriptions,
                    selectedOutputFormats: this.state.selectedOutputFormats,
                    agentInstructions: this.state.agentInstructions || ''
                };

                console.log('Sending build agent request:', requestBody);

                const response = await fetch(API_Backend_Root + "build-agent/", {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json',
                        'accessKey': access_key,
                        'secretKey': secret_key
                    },
                    body: JSON.stringify(requestBody)
                });

                if (!response.ok) {
                    throw new Error(`Failed to build agent: ${response.status}`);
                }

                const data = await response.json();
                
                if (data.error) {
                    throw new Error(data.error);
                }
                
                console.log('Agent built successfully:', data);
                this.setState({ loading: false });
                
                // Redirect to the agent's update page
                if (data.agent_hash) {
                    this.props.navigateTo(`/agent/${data.agent_hash}`);
                } else {
                    throw new Error('Agent hash not returned from server');
                }
                    
            } catch (error) {
                console.error('Error building agent:', error);
                this.setState({ 
                    error: error.message || "Failed to build agent",
                    loading: false 
                });
            }
        }
    }

    renderStepContent = () => {
        switch(this.state.currentStep) {
            case 1:
                return (
                    <div style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '20px', color: '#333' }}>Step 1: Pick your file(s)</h3>
                        
                        {this.state.loading && (
                            <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                                Loading your files...
                            </div>
                        )}

                        {this.state.error && (
                            <div style={{ 
                                backgroundColor: '#ffebee', 
                                color: '#c62828', 
                                padding: '12px', 
                                borderRadius: '4px', 
                                marginBottom: '20px' 
                            }}>
                                Error: {this.state.error}
                            </div>
                        )}

                        {!this.state.loading && !this.state.error && (
                            <div>
                                <div style={{ marginBottom: '20px', color: '#666', fontSize: '14px' }}>
                                    Selected files: {this.state.selectedFiles.length} / {this.state.files.length}
                                </div>
                                
                                {this.state.files.length === 0 ? (
                                    <div style={{ 
                                        textAlign: 'center', 
                                        padding: '40px', 
                                        color: '#666',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '6px'
                                    }}>
                                        No files found. Upload some files first to create an agent.
                                    </div>
                                ) : (
                                    <div style={{ 
                                        display: 'grid', 
                                        gap: '10px',
                                        maxHeight: '400px',
                                        overflowY: 'auto'
                                    }}>
                                        {this.state.files.map(file => (
                                            <div
                                                key={file.pkID}
                                                onClick={() => {
                                                    if (this.state.selectedFiles.includes(file.fileHash)) {
                                                        this.handleFileDeselect(file.fileHash);
                                                    } else {
                                                        this.handleFileSelect(file.fileHash);
                                                    }
                                                }}
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    padding: '12px 16px',
                                                    border: this.state.selectedFiles.includes(file.fileHash) 
                                                        ? '2px solid #70BB98' 
                                                        : '1px solid #ddd',
                                                    borderRadius: '6px',
                                                    backgroundColor: this.state.selectedFiles.includes(file.fileHash) 
                                                        ? '#f0f8f5' 
                                                        : 'white',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s ease',
                                                    marginRight: '6px'
                                                }}
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={this.state.selectedFiles.includes(file.fileHash)}
                                                    onChange={() => {}} // Handled by parent div onClick
                                                    style={{ marginRight: '12px' }}
                                                />
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ 
                                                        fontWeight: '500', 
                                                        color: '#333',
                                                        marginBottom: '4px'
                                                    }}>
                                                        {file.name || 'Untitled File'}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666' 
                                                    }}>
                                                        {file.fileType || 'Unknown type'} • 
                                                        {file.createdDt ? new Date(file.createdDt).toLocaleDateString() : 'Unknown date'}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                );
            case 2:
                return (
                    <div style={{ padding: '20px' }}>
                        <h3 style={{ marginBottom: '24px', color: '#333' }}>Step 2: Build Agent</h3>
                        
                        <div style={{ marginBottom: '20px' }}>
                            <div>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Agent Name
                                </h4>
                                <input
                                    type="text"
                                    placeholder="Enter a name for your agent..."
                                    value={this.state.agentName}
                                    onChange={this.handleAgentNameChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        fontFamily: 'Lato, sans-serif',
                                        outline: 'none',
                                        marginBottom: '20px'
                                    }}
                                />
                            </div>
                            <div>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    Agent Description
                                </h4>
                                <input
                                    type="text"
                                    placeholder="Briefly describe what this agent does..."
                                    value={this.state.agentDescription}
                                    onChange={this.handleAgentDescriptionChange}
                                    style={{
                                        width: '100%',
                                        padding: '12px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        fontFamily: 'Lato, sans-serif',
                                        outline: 'none'
                                    }}
                                />
                            </div>
                        </div>
                        
                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ 
                                marginBottom: '16px', 
                                color: '#333',
                                fontSize: '18px',
                                fontWeight: '600'
                            }}>
                                Agent Instructions
                            </h4>
                            <textarea
                                placeholder="Enter instructions for your AI agent. Describe what you want the agent to do with the selected files..."
                                value={this.state.agentInstructions}
                                onChange={this.handleAgentInstructionsChange}
                                style={{
                                    width: '100%',
                                    minHeight: '300px',
                                    maxHeight: '500px',
                                    padding: '12px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    fontSize: '14px',
                                    fontFamily: 'Lato, sans-serif',
                                    resize: 'vertical',
                                    outline: 'none',
                                    overflow: 'auto'
                                }}
                            />
                        </div>

                        {this.state.selectedFiles.length > 0 && (
                            <div style={{ marginBottom: '20px' }}>
                                <h4 style={{ 
                                    marginBottom: '16px', 
                                    color: '#333',
                                    fontSize: '18px',
                                    fontWeight: '600'
                                }}>
                                    File Descriptions
                                </h4>
                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 2fr',
                                    gap: '20px',
                                    height: '300px',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    overflow: 'hidden'
                                }}>
                                    <div style={{
                                        backgroundColor: '#f8f9fa',
                                        borderRight: '1px solid #ddd',
                                        overflowY: 'auto'
                                    }}>
                                        {this.state.selectedFiles.map(fileHash => {
                                            const file = this.state.files.find(f => f.fileHash === fileHash);
                                            const isSelected = this.state.selectedFileForDescription === fileHash;
                                            return (
                                                <div
                                                    key={fileHash}
                                                    onClick={() => this.handleFileSelectForDescription(fileHash)}
                                                    style={{
                                                        padding: '12px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: isSelected ? '#e3f2fd' : 'transparent',
                                                        borderBottom: '1px solid #e0e0e0',
                                                        transition: 'background-color 0.2s ease',
                                                        borderLeft: isSelected ? '3px solid #70BB98' : '3px solid transparent'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!isSelected) {
                                                            e.target.style.backgroundColor = '#f0f0f0';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!isSelected) {
                                                            e.target.style.backgroundColor = 'transparent';
                                                        }
                                                    }}
                                                >
                                                    <div style={{ 
                                                        fontWeight: isSelected ? '600' : '500', 
                                                        color: '#333',
                                                        marginBottom: '4px',
                                                        fontSize: '14px'
                                                    }}>
                                                        {file ? file.name : `File ${fileHash}`}
                                                    </div>
                                                    <div style={{ 
                                                        fontSize: '12px', 
                                                        color: '#666' 
                                                    }}>
                                                        {file ? file.fileType : 'Unknown type'}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>

                                    {/* Right column - Description textarea */}
                                    <div style={{ padding: '16px' }}>
                                        {this.state.selectedFileForDescription ? (
                                            <div>
                                                <label style={{ 
                                                    display: 'block', 
                                                    marginBottom: '8px', 
                                                    fontWeight: '500', 
                                                    color: '#333',
                                                    fontSize: '14px'
                                                }}>
                                                    Description for {(() => {
                                                        const selectedFile = this.state.files.find(f => f.fileHash === this.state.selectedFileForDescription);
                                                        return selectedFile ? selectedFile.name : `File ${this.state.selectedFileForDescription}`;
                                                    })()}
                                                </label>
                                                <textarea
                                                    placeholder="Describe what this file contains and how it should be used..."
                                                    value={this.state.fileDescriptions[this.state.selectedFileForDescription] || ''}
                                                    onChange={(e) => this.handleFileDescriptionChange(this.state.selectedFileForDescription, e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        padding: '12px',
                                                        border: '1px solid #ddd',
                                                        borderRadius: '6px',
                                                        fontSize: '14px',
                                                        fontFamily: 'Lato, sans-serif',
                                                        resize: 'vertical',
                                                        outline: 'none'
                                                    }}
                                                />
                                            </div>
                                        ) : (
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                height: '100%',
                                                color: '#666',
                                                fontSize: '14px',
                                                textAlign: 'center'
                                            }}>
                                                Select a file from the left to add a description
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}

                        <div style={{ marginBottom: '20px' }}>
                            <h4 style={{ 
                                marginBottom: '16px', 
                                color: '#333',
                                fontSize: '18px',
                                fontWeight: '600'
                            }}>
                                Output File Formats
                            </h4>
                            <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '8px',
                                marginBottom: '16px'
                            }}>
                                {['.xlsx', '.pdf', '.html', '.docx', '.csv'].map(format => {
                                    const isSelected = this.state.selectedOutputFormats.includes(format);
                                    return (
                                        <button
                                            key={format}
                                            onClick={() => this.handleOutputFormatToggle(format)}
                                            style={{
                                                padding: '8px 16px',
                                                border: isSelected ? '2px solid #70BB98' : '1px solid #ddd',
                                                borderRadius: '6px',
                                                backgroundColor: isSelected ? '#f0f8f5' : 'white',
                                                cursor: 'pointer',
                                                fontSize: '14px',
                                                fontWeight: '500',
                                                color: isSelected ? '#70BB98' : '#333',
                                                transition: 'all 0.2s ease',
                                                outline: 'none'
                                            }}
                                            onMouseEnter={(e) => {
                                                if (!isSelected) {
                                                    e.target.style.backgroundColor = '#f5f5f5';
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (!isSelected) {
                                                    e.target.style.backgroundColor = 'white';
                                                }
                                            }}
                                        >
                                            {format}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                        
                        <div style={{ 
                            marginTop: '20px', 
                            padding: '12px', 
                            backgroundColor: '#f5f5f5', 
                            borderRadius: '6px',
                            color: '#666',
                            fontSize: '14px'
                        }}>
                            <strong>Selected files:</strong> {this.state.selectedFiles.length} files
                        </div>
                    </div>
                );
            default:
                return <div>No content available for this step.</div>;
        }
    }

    render() {
        return (
            <div style={{ padding: "24px 48px" }}>
                <div style={{ marginBottom: "20px", color: '#333', display: 'flex', gap: '6px', fontFamily: 'Lato', alignItems: 'center', borderBottom: '1px solid #9696A0', paddingBottom: '16px' }}>
                    <button 
                        onClick={this.handleBackToAgents}
                        style={{
                            backgroundColor: '#fff', 
                            color: '#333', 
                            borderRadius: '5px', 
                            border: 'none', 
                            cursor: 'pointer', 
                            fontSize: '24px',
                            fontWeight: '600',
                            outline: 'none'
                        }}
                    >
                        ←
                    </button>
                    <h2>Build your agent</h2>
                </div>
                
                {/* Main content box with 3 columns */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '250px 1fr 250px',
                    gap: '20px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    padding: '20px',
                    minHeight: '500px',
                    border: '1px solid #9696A0'
                }}>
                    {/* Left column - Steps */}
                    <div style={{ backgroundColor: 'white', borderRadius: '6px', padding: '4px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <button
                                onClick={() => this.handleStepClick(1)}
                                style={{
                                    border: this.state.currentStep === 1 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 1 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    fontWeight: this.state.currentStep === 1 ? '600' : '400',
                                    color: this.state.currentStep === 1 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '10px 16px'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Step 1</span>                              
                                <span style={{fontWeight: '400'}}> &nbsp; Pick your file</span>
                            </button>
                            <button
                                onClick={() => this.handleStepClick(2)}
                                style={{
                                    border: this.state.currentStep === 2 ? '1px solid #70BB98' : '1px solid #9696A0',
                                    borderRadius: '6px',
                                    backgroundColor: this.state.currentStep === 2 ? '#70BB98' : 'white',
                                    cursor: 'pointer',
                                    textAlign: 'left',
                                    fontSize: '14px',
                                    fontWeight: this.state.currentStep === 2 ? '600' : '400',
                                    color: this.state.currentStep === 2 ? '#FFF' : '#333',
                                    outline: 'none',
                                    padding: '10px 16px'
                                }}
                            >
                                <span style={{fontWeight: '600'}}>Step 2</span>                              
                                <span style={{fontWeight: '400'}}> &nbsp; Build agent</span>
                            </button>
                        </div>
                    </div>

                    {/* Middle column - Dynamic content */}
                    <div style={{ backgroundColor: 'white', borderRadius: '0px', padding: '20px', borderLeft: '1px solid #9696A0', borderRight: '1px solid #9696A0' }}>
                        {this.state.loading ? (
                            <div style={{ 
                                textAlign: 'center', 
                                padding: '40px', 
                                color: '#666' 
                            }}>
                                <div style={{ 
                                    fontSize: '18px', 
                                    marginBottom: '10px' 
                                }}>
                                    Building your agent...
                                </div>
                                <div style={{ 
                                    fontSize: '14px' 
                                }}>
                                    This may take a few moments
                                </div>
                            </div>
                        ) : (
                            this.renderStepContent()
                        )}
                        
                        {/* Next/Build Agent button */}
                        {!this.state.loading && (
                            <div style={{ 
                                display: 'flex', 
                                justifyContent: 'flex-end', 
                                marginTop: '20px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e0e0e0'
                            }}>
                                <button
                                    onClick={this.handleNext}
                                    disabled={this.state.loading}
                                    style={{
                                        backgroundColor: this.state.loading ? '#ccc' : '#70BB98',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '6px',
                                        padding: '12px 24px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        cursor: this.state.loading ? 'not-allowed' : 'pointer',
                                        outline: 'none',
                                        transition: 'background-color 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (!this.state.loading) {
                                            e.target.style.backgroundColor = '#5da085';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!this.state.loading) {
                                            e.target.style.backgroundColor = '#70BB98';
                                        }
                                    }}
                                >
                                    {this.state.loading ? 'Building Agent...' : (this.state.currentStep === 1 ? 'Next →' : 'Build Agent')}
                                </button>
                            </div>
                        )}
                    </div>

                    {/* Right column - Help */}
                    <div style={{ backgroundColor: 'white', borderRadius: '0px', padding: '20px' }}>
                        <h3 style={{ marginBottom: '20px', color: '#333' }}>Help</h3>
                        <div style={{ color: '#666', fontSize: '14px', lineHeight: '1.5' }}>
                            {this.state.currentStep === 1 && (
                                <div>
                                    <p style={{ marginBottom: '10px' }}>Pick your file(s) here. You can select from your uploaded files to work with your AI agent.</p>
                                    <p style={{ marginBottom: '10px' }}>You can select 0-20 files.</p>
                                    <p>Selected files: {this.state.selectedFiles.length}</p>
                                </div>
                            )}
                            {this.state.currentStep === 2 && (
                                <p>Configure your agent settings and parameters here.</p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapActionsToProps = {
    navigateTo: push
}

export default connect(null, mapActionsToProps)(AgentsBuildIndex)
